import doublesImage from "../../assets/blog/tennis-singles-doubles.webp";

export const tennisSinglesVsDoubles = {
  id: 6,
  slug: "tennis-singles-vs-doubles",
  title: "Tennis Singles vs Doubles Strategy: Key Differences",
  excerpt: "Singles and doubles reward different tactics. Discover how to adjust your mindset and tactics when switching between disciplines.",
  seoTitle: "Tennis Singles vs Doubles Strategy | Racketly",
  seoDescription: "Compare tennis singles and doubles strategy, from court coverage to net play and shot selection. Adapt your positioning and tactics for your next match.",
  date: "2026-01-03",
  updatedAt: "2026-10-06",
  category: "Tennis",
  image: doublesImage,
  imageWidth: 1200,
  imageHeight: 810,
  imageAlt: "Four tennis players competing in a mixed doubles match on grass",
  imageCaption: "Mixed doubles on the grass courts at Wimbledon.",
  imageCredit: "Carine06 via Wikimedia Commons",
  imageCreditUrl: "https://commons.wikimedia.org/wiki/File:Mixed_doubles_semi-final_(50498709556).jpg",
  imageLicense: "CC BY-SA 2.0",
  imageLicenseUrl: "https://creativecommons.org/licenses/by-sa/2.0/",
  imagePosition: "center 48%",
  content: `
  <p class="mb-4">Singles is a game of angles and consistency. Doubles is a game of positioning and quick reflexes. Trying to play singles tactics on a doubles court is a recipe for disaster.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">Court Coverage</h2>
  <p class="mb-4">In singles, you have to cover the whole court, so recovery to the center hash is vital. In doubles, you only cover half (mostly). This encourages more aggressive net play and interception.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">The Net Game</h2>
  <p class="mb-4">In singles, coming to the net is a finishing move. In doubles, it's the primary objective. The team that controls the net usually controls the match.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">Shot Selection</h2>
  <p class="mb-4">Cross-court is king in doubles to keep the ball away from the net player. Down-the-line is a high-risk surprise shot. In singles, down-the-line is often used to attack a weak backhand or open up the court.</p>
`,
};
